<template>
    <div class="container">
            <Sidebar />
            <div class="main-content">
                <router-view></router-view>
            </div>
    </div>
</template>

<script>
import Sidebar from '../partials/Sidebar'
    export default {
        name:'dashboard',
        components: {
            Sidebar
        }
    }
</script>
